import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VendorBills from "../components/VendorBills";

const VendorBillsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Bills/Invoices' />

                <VendorBills />

            </MasterLayout>
        </>
    );
};

export default VendorBillsPage;
